<template>
  <h2>Тип подписи</h2>
  <section class="btns-block">
    <ShadowBlock
      class="clickable"
      :class="{ checked: modelValue === 'пэп' }"
      @click="selectType('пэп')"
    >
    <PepIcon />
      ПЭП
    </ShadowBlock>

    <ShadowBlock
      class="clickable"
      :class="{ checked: modelValue === 'кэп' }"
      @click="selectType('кэп')"
    >
    <KepIcon />
        КЭП
    </ShadowBlock>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import ShadowBlock from "../ShadowBlock.vue";
import PepIcon from "@/components/icons/PepIcon.vue";
import KepIcon from "@/components/icons/KepIcon.vue";

export default defineComponent({
  name: "CSignatureType",
  components: {
    ShadowBlock,
    PepIcon,
    KepIcon,
  },
  props: {
    modelValue: {
      type: String as PropType<'пэп' | 'кэп'>,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    selectType(type: 'пэп' | 'кэп') {
      this.$emit("update:modelValue", type);
      if(type === 'кэп'){
        //eslint-disable-next-line
        check_plugin_working()
      }
    },
  },
});
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
</style>
